export default function getShareDescriptions({
  type,
  title,
  isTutor,
}: {
  type: 'session' | 'series'
  title: string
  isTutor: boolean
}): { long: string; short: string } {
  return {
    long: isTutor
      ? `I'm hosting a ${type} about ${title} on https://schoolhouse.world, a free online tutoring platform. You should check it out!`
      : `I found a ${type} about ${title} on https://schoolhouse.world, a free online tutoring platform. You should check it out!`,
    short: isTutor
      ? `Check out this ${type} I'm hosting on Schoolhouse.world!`
      : `Check out this ${type} on Schoolhouse.world!`,
  }
}
